import { useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Api from '../../../Apis/api.service'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment } from '@material-ui/core'

export default function PasswordDialog({ open, setOpen, onConfirm }) {
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const handleClose = () => {
    setOpen(false)
    setErrorMsg('')
  }
  const handleClickShowPassword = () =>
    setShowPassword((showPassword) => !showPassword)

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const res = await Api.ags.confirmPassword({ password })
    console.log({ res })
    if (res.status == 201 && res.data.ok) {
      onConfirm()
      handleClose()
    } else {
      setError(true)
      setErrorMsg(res.data.message)
    }
  }
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Pour consulter la piece d’identité veuillez saisir le mot de passe.
        </DialogContentText>
        <TextField
          error={error}
          autoFocus
          margin="dense"
          id="password"
          label="Mot de passe"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          variant="standard"
          onChange={(e) => {
            setPassword(e.target.value)
            setError(false)
            setErrorMsg('')
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          helperText={error ? errorMsg : false}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
        <Button onClick={onSubmit} disabled={!password}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  )
}
